<template>
  <div>
    <Breadcrumbs title="Industry"/>
    <div class="container-fluid">
      <div class="row">

        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 box-col-4 xl-50">
                  <div class="card ecommerce-widget" @click="board='main'">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-5">
                          <span>MAIN</span>
                          <h3 class="total-num counter">{{ $store.state.menu.stocks.filter(s => s.board==='main').length }}</h3>
                        </div>
                        <div class="col-7">
                          <div class="text-md-right">
                            <ul>
                              <li>
                                Profit
                                <b><span class="product-stts txt-success ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='main' && s.i_close > s.open).length }}
                                  <i class="icon-angle-up f-12 ml-1"></i>
                                </span></b>
                              </li>
                              <li>
                                Loss
                                <b><span class="product-stts txt-danger ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='main' && s.i_close < s.open).length }}
                                  <i class="icon-angle-down f-12 ml-1"></i>
                                </span></b>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="progress-showcase">
                        <div class="progress sm-progress-bar">
                          <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="[{width: Math.round($store.state.menu.stocks.filter(s => s.board==='main' && s.i_close > s.open).length/$store.state.menu.stocks.filter(s => s.board==='main').length*100)+'%' }]"
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 box-col-4 xl-50">
                  <div class="card ecommerce-widget" @click="board='ace'">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-5">
                          <span>ACE</span>
                          <h3 class="total-num counter">{{ $store.state.menu.stocks.filter(s => s.board==='ace').length }}</h3>
                        </div>
                        <div class="col-7">
                          <div class="text-md-right">
                            <ul>
                              <li>
                                Profit
                                <b><span class="product-stts txt-success ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='ace' && s.i_close > s.open).length }}
                                  <i class="icon-angle-up f-12 ml-1"></i>
                                </span></b>
                              </li>
                              <li>
                                Loss
                                <b><span class="product-stts txt-danger ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='ace' && s.i_close < s.open).length }}
                                  <i class="icon-angle-down f-12 ml-1"></i>
                                </span></b>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="progress-showcase">
                        <div class="progress sm-progress-bar">
                          <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="[{width: Math.round($store.state.menu.stocks.filter(s => s.board==='ace' && s.i_close > s.open).length/$store.state.menu.stocks.filter(s => s.board==='ace').length*100)+'%' }]"
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 box-col-4 xl-50">
                  <div class="card ecommerce-widget" @click="board='leap'">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-5">
                          <span>LEAP</span>
                          <h3 class="total-num counter">{{ $store.state.menu.stocks.filter(s => s.board==='leap').length }}</h3>
                        </div>
                        <div class="col-7">
                          <div class="text-md-right">
                            <ul>
                              <li>
                                Profit
                                <b><span class="product-stts txt-success ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='leap' && s.i_close > s.open).length }}
                                  <i class="icon-angle-up f-12 ml-1"></i>
                                </span></b>
                              </li>
                              <li>
                                Loss
                                <b><span class="product-stts txt-danger ml-2">
                                  {{ $store.state.menu.stocks.filter(s => s.board==='leap' && s.i_close < s.open).length }}
                                  <i class="icon-angle-down f-12 ml-1"></i>
                                </span></b>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="progress-showcase mt-4">
                        <div class="progress sm-progress-bar">
                          <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="[{width: Math.round($store.state.menu.stocks.filter(s => s.board==='leap' && s.i_close > s.open).length/$store.state.menu.stocks.filter(s => s.board==='leap').length*100)+'%' }]"
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive datatable-vue">
                <b-table
                    selectable
                    show-empty
                    stacked="md"
                    selectedVariant="success"
                    :items="progress[board]"
                    :fields="tablefields"
                    :filter="filter"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :select-mode="'single'"
                    @filtered="onFiltered"
                    @row-selected="industrySelected"
                >
                </b-table>
              </div>
            </div>

            <div class="card-body">
              <b-row>
                <b-col xl="6">
                  <b-input-group class="datatable-btn">
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col xl="6">
                  <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue">
                <b-table
                    selectable
                    show-empty
                    stacked="md"
                    selectedVariant="success"
                    :items="stocks.filter(s => s.primary_industry === primary_industry && s.board === board)"
                    :fields="stockfields"
                    :filter="filter"
                    :current-page="currentPageS"
                    :per-page="perPage"
                    select-mode="single"
                    @filtered="onFilteredS"
                    @row-selected="stockSelected"
                >
                </b-table>
              </div>
              <b-col md="6" class="my-1 p-0">
                <b-pagination
                    v-model="currentPageS"
                    :total-rows="totalRowsS"
                    :per-page="perPage"
                    class="my-0"
                ></b-pagination>
              </b-col>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      progress: {
        ace: [],
        leap: [],
        main: []
      },
      board: 'main',
      tablefields: [
        { key: 'primary_industry', label: 'Industry', sortable: true, },
        { key: 'market_cap', label: 'Market Cap', sortable: true, },
        { key: 'count', label: 'Count', sortable: true, },
        { key: 'today_up', label: 'Up', sortable: true, },
        { key: 'today_down', label: 'Down', sortable: true, },
        { key: 'today_up_pct', label: 'Up %', sortable: true, },
        { key: 'last_week_up', label: 'W Up', sortable: true, },
        { key: 'last_week_down', label: 'W Down', sortable: true, },
        { key: 'last_week_up_pct', label: 'W Up %', sortable: true, },
        { key: 'last_month_up', label: 'M Up', sortable: true, },
        { key: 'last_month_down', label: 'M Down', sortable: true, },
        { key: 'last_month_up_pct', label: 'M Up %', sortable: true, },
        { key: 'last_year_up', label: 'Y Up', sortable: true, },
        { key: 'last_year_down', label: 'Y Down', sortable: true, },
        { key: 'last_year_up_pct', label: 'Y Up %', sortable: true, },
      ],

      stocks: [],
      primary_industry: '',
      stockfields: [
        { key: 'id', label: 'ID', sortable: true, },
        { key: 'name', label: 'Ticker', sortable: true, },
        { key: 'market_cap', label: 'Market Cap', sortable: true, },
        { key: 'today_pct', label: '%', sortable: true, },
        { key: 'last_week_pct', label: 'W %', sortable: true, },
        { key: 'last_month_pct', label: 'M %', sortable: true, },
        { key: 'last_year_pct', label: 'Y %', sortable: true, },
      ],
      stock: null,

      filter: null,
      totalRows: 1,
      totalRowsS: 1,
      currentPage: 1,
      currentPageS: 1,
      perPage: 25,
      pageOptions: [25, 100, 1000],
    }
  },
  computed: {
    title: function () { return 'Industry Progress' },
    sortOptions() {
      return this.tablefields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
    },
    sortOptionsS() {
      return this.stockfields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
    }
  },
  watch: {
    title: { immediate: true, handler() { document.title = this.title } }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.fetchIndustry()
    },
    fetchIndustry() {
      this.$http.get(`/api/stock/industry/progress`)
          .then(({data}) => {
            this.progress = data.progress
            this.stocks = data.stocks
          })
          .catch(e => console.log(e.message))
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onFilteredS(filteredItems) {
      this.totalRowsS = filteredItems.length
      this.currentPageS = 1
    },
    industrySelected(item) {
      this.primary_industry = item[0].primary_industry
    },
    stockSelected(item) {
      this.stock = item[0]
    },
  }
}
</script>